<!--
IMPORTACAO DE CADASTROS PELO XML DA NF-E
-->

<script>
import BarList from '../components/bar-list'
import { apiValidaLimitePlano, urlORDS } from '../shared/api-functions'
import axios from 'axios'
import { getText,  } from '../shared/utils'

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            filial: '',
            codfil: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            filesJson: [],
            resultList: [],
            showSelecionaArquivos: true,
            showConfirmaImportacao: false,
            transcount: 0,
            prodcountutos: 0,
            clicountentes: 0,
            forncount: 0,
        }
    },

    computed: {
        qtFiles: function () {
            return this.filesJson.length
        },


    },

    filters: {
        getText: function (value, metadata) {
            return getText(value, metadata)
        },
    },

    methods: {
        handleFileSelectBtn() {
            //BOTAO SELECIONAR ARQUIVOS
            this.$refs.file.value = ''
            this.$refs.file.click()
        },

        handleFileUpload () {
            //EVENTO AO SELECIONAR ARQUIVOS
            //EFETUA A LEITURA DE CADA ARQUIVO SELECIONADO ATRAVES DO SERVIDOR (SERVIDOR RETORNA O XML)

            //console.log(this.$refs.file.files)

            var files = this.$refs.file.files
            this.filesJson = []

            if (files.length > 50) {
               this.$erpToastError('Seleção não permitida. O limite máximo é de 50 arquivos por importação.')
               return
            }

            let self = this

            //formData.append('file', this.selectedFile)
            for( var i = 0; i < files.length; i++ ){
                let file = files[i]
                let reader = new FileReader()
                reader.readAsText(file, 'ISO-8859-1')
                reader.onload = function (event) {
                    let xml = event.target.result
                    self.readXml(xml, file.name)
                }
            }
            this.showSelecionaArquivos = false
            this.showConfirmaImportacao = true
        },

        readXml(xml, filename) {
            let self = this
            let formData = new FormData()
            formData.append('file', new Blob([xml]), filename)
            axios.post(urlORDS(this.$store, 'cg/importreadxml/'), formData,
                { headers: { 'Content-Type': 'multipart/form-data', } }
            ).then(function(data){
                    let addfile = { filename: filename, xml: data.data }
                    self.filesJson.push(addfile)
                    console.log(self.filesJson)
                })
                .catch(function(data){
                    self.$erpToastError('Erro ao efetuar upload do arquivo ' + file.name + ': ' + data.message)
                })
        },

        handleExecutaImportacao () {
            //ENVIA O OBJETO JSON PARA IMPORTAÇÃO
            //RETORNA UM OBJETO ARRAY COM A SITUACAO DE CADA ITEM IMPORTADO E OS ERROS SE HOUVER
            //[ filename: "", status: "ok", errormessage: "", text: ""]

            let sendData = { xmls: this.filesJson }
            this.resultList = []

            var self = this

            axios.post(urlORDS(this.$store, 'cg/importxml/'), sendData, {})
                .then(function(data){
                    // console.log(data.data)
                    self.transcount = data.data.transcount
                    self.forncount = data.data.forncount
                    self.prodcount = data.data.prodcount
                    self.clicount = data.data.clicount
                    self.resultList = data.data.result
                    self.$erpToastSuccess('Importação executada')
                    self.showConfirmaImportacao = false
                })
                .catch(function(data){
                    self.$erpToastError('Erro ao efetuar importação ' + data.message)
                })
        },

        async loadData() {
            // this.$store.dispatch('loadFilial', { filter: this.filter, page: this.nextPage } )
        },

        handleRetornar () {
            this.resultList = []
            this.showSelecionaArquivos = true
            this.showConfirmaImportacao = false
        },

        closeForm () {
          // this.$router.go(-1)
          this.$emit('closeform')
        },


    },

    components: {
        BarList
    },

    created () {
        this.loadData()
    },

    async mounted(){
      const isValid = await apiValidaLimitePlano(this, 'importarcadastros')
      if (!isValid)
        this.closeForm()


    }

}

</script>

<template>
    <div>
        <bar-manut
            single-entity="Importação de Cadastros Por XML"
            :disableSave="true"
            :disableRetorno="true">
        </bar-manut>

        <div class="default-container" v-if="showSelecionaArquivos">
            <label-title title="Selecionar Arquivos XML de NF-e" class="mb-2"></label-title>
            <span class="w-100 lbl">Importe agora dados de produtos, destinatários e emitentes através dos arquivos XML de suas notas de saída e entrada</span>
            <hr>
            <div class="row mt-5 mb-5">
                <div class="col-md-12">
                    <span class="w-100 lbl-edit">A importação de dados é feita através dos arquivos XML de notas fiscais da sua Empresa</span>
                    <span class="w-100 lbl-edit">Selecione até 50 arquivos de XML</span>
                </div>
                <div class="col-md-12 mt-2">
                </div>
                <div class="col-md-12 mt-2">
                    <!-- <alert v-if="errmessage" type="warning" title="Erro na importação do arquivo" :text="errmessage"></alert> -->
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-12 mt-2">
                    <v-button label="Selecionar Arquivos XML" :nb-btdef="false" icon="fa-upload" @click="handleFileSelectBtn()"></v-button>
                    <!-- <v-button label="Continuar" :nb-btdef="true" @click="handleAnalisarArquivo()"></v-button> -->
                    <!-- <v-button label="Cancelar" @click="handleRetornar()"></v-button> -->
                </div>
            </div>
        </div>

        <div class="default-container" v-if="showConfirmaImportacao">
            <label-title title="Confirmar Importação" class="mb-2"></label-title>
            <hr>
            <div class="row">
                <div class="col-md-12">
                    <alert type="warning" text="Serão ignorados os registros de produtos, clientes, fornecedores ou transportadoras já existentes no sistema"></alert>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-12">
                    <span class="w-100 lbl-edit">Confirme a importação de {{ qtFiles }} arquivos XML</span>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-12 mt-2">
                    <v-button label="Continuar" :nb-btdef="true" @click="handleExecutaImportacao()"></v-button>
                    <v-button label="Cancelar" @click="handleRetornar()"></v-button>
                </div>
            </div>
        </div>

        <div class="default-container" v-if="resultList.length > 0">
            <label-title title="Resultado da importação" class="mb-2"></label-title>
            <hr>
            <div class="row mt-5 mb-5">
                <div class="col-md-3 col-3 col-3">
                    <div class="card h-100 text-center">
                        <div class="card-header">
                            <label class="lbl-title">Clientes Importados</label>
                        </div>
                        <div class="card-body">
                            <label class="lbl-edit"> {{ clicountentes }} </label>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-3 col-3">
                    <div class="card text-center">
                        <div class="card-header">
                            <label class="lbl-title">Fornecedores Importados</label>
                        </div>
                        <div class="card-body">
                            <label class="lbl-edit"> {{ forncount }} </label>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-3 col-3">
                    <div class="card text-center">
                        <div class="card-header">
                            <label class="lbl-title">Produtos Importados</label>
                        </div>
                        <div class="card-body">
                            <label class="lbl-edit"> {{ prodcountutos }} </label>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-3 col-3">
                    <div class="card text-center">
                        <div class="card-header">
                            <label class="lbl-title">Transportadoras Importadas</label>
                        </div>
                        <div class="card-body">
                            <label class="lbl-edit"> {{ transcount }} </label>
                        </div>
                    </div>
                </div>
            </div>

            <label-title title="Detalhes da importação"></label-title>
            <div class="mainbox" v-for="(item, index) in resultList" v-bind:key="index">
                <div v-if="item.status=='error'" class="mark-red"></div>
                <div v-if="item.status!='error'" class="mark-green"></div>
                <div class="box">
                    <div class="row">
                        <div class="col-md-4 col-6">
                            <v-label label="Arquivo"></v-label><br>
                            <span class="data-list">{{ item.filename }}</span>
                        </div>
                        <div class="col-md-4 col-6">
                            <v-label label="Descrição"></v-label><br>
                            <span class="data-list">{{ item.text }}</span>
                        </div>
                        <div class="col-md-4 col-6">
                            <v-label label="Mensagem"></v-label><br>
                            <span class="data-list">{{ item.errormessage }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row col">
                <v-button label="Retornar" @click="handleRetornar" icon="fa-arrow-left"></v-button>
            </div>
        </div>


        <div v-show="false" class="row">
            <div class="col">
                <label>Foto
                        <input type="file" ref="file" multiple accept=".xml" @change="handleFileUpload()">
                </label>
            </div>
        </div>


    </div>


</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/importa-xml.vue